// src/components/DataTable.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import DTTable from '../../components/AntdTable';
import { API_URL, ENDPOINTS } from '../../constants/api';
import { decodeToken, getToken } from '../../utils/TokenUtils';
import HorizontalForm from '../../components/HorizontalForm';
import ModalForm from '../../components/ModalForm';
import { useTranslation } from 'react-i18next';
import ActivityReport from './ActivityReport';
import MapView from '../../components/MapView';
import { fetchForm } from '../../utils/ktcUtils';
import BalanceSheet from './Accounting/BalanceSheet';
import TrialBalance from './Accounting/TrialBalance';
import ActivityReport2 from './ActivityReport2';

const ReportForm = () => {
  const { t } = useTranslation();
  const [report, setReport] = useState([]);
  const [reportHeader, setReportHeader] = useState([]);
  const [reportFooter, setReportFooter] = useState([]);
  const [permissions, setPermissions] = useState([]);

  const token = getToken();
  const userId = decodeToken(token, 'id');
  const branchId = decodeToken(token, 'branch_id');

  const [loading, setLoading] = useState(true);
  const { route } = useParams(); // Retrieve the param from the URL

  const [link, setLink] = useState([]);
  const [inputs, setInputs] = useState([]);
  const [values, setValues] = useState([]);

  const [executionTime, setExecutionTime] = useState(null);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const [currentRoute, setCurrentRoute] = useState(null);

  const params = new URLSearchParams(window.location.search);
  const queryObj = Object.fromEntries(params.entries());

  const openModal2 = (route) => {
    setCurrentRoute(route);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  useEffect(() => {
    setReport([]);
    const url = `${API_URL}/${ENDPOINTS.SYS}/createform/${route}`;

    fetchForm({
      url,
      queryObj,
      setLink,
      setInputs,
      setValues,
      setLoading,
    });
  }, [route]);

  //console.log('link:', link);

  //activity report print
  const printAcivityReport = (e) => {
    e.preventDefault(); // Prevent default behavior of the Link

    localStorage.setItem('printData', ''); // Store data in localStorage
    localStorage.setItem('printData', JSON.stringify(report)); // Store data in localStorage
    localStorage.setItem('linkData', ''); // Store data in localStorage
    localStorage.setItem('linkData', JSON.stringify(link)); // Store data in localStorage

    window.open('/print-activity', '_blank'); // Open the link in a new tab
  };

  const printAcivityReport2 = (e) => {
    e.preventDefault(); // Prevent default behavior of the Link

    localStorage.setItem('printData', ''); // Store data in localStorage
    localStorage.setItem('printData', JSON.stringify(report)); // Store data in localStorage
    localStorage.setItem('linkData', ''); // Store data in localStorage
    localStorage.setItem('linkData', JSON.stringify(link)); // Store data in localStorage

    window.open('/print-activity2', '_blank'); // Open the link in a new tab
  };
  return (
    <>
      {isModalOpen && currentRoute && (
        <ModalForm
          userId={userId}
          token={token}
          route={currentRoute} // Pass the dynamic route to the modal
          isOpen={isModalOpen}
          onRequestClose={closeModal}
        />
      )}

      <HorizontalForm
        token={token}
        link={link}
        values={values}
        inputs={inputs}
        setInputs={setInputs}
        setData={setReport}
        setReportHeader={setReportHeader}
        setReportFooter={setReportFooter}
        setPermissions={setPermissions}
        setValues={setValues}
        setExecutionTime={setExecutionTime}
      />

      {/* {report && report.length === 0 && 
        <p>No Data </p>
      }  */}

      {report &&
        report.length > 0 &&
        link.form_type === 'activity-report' &&
        API_URL.includes('kaah') && (
          <>
            <center>
              <button className="btn btn-danger" onClick={printAcivityReport2}>
                Print Report
              </button>
            </center>

            <ActivityReport2 sections={report} link={link} />
          </>
        )}

      {report &&
        report.length > 0 &&
        link.form_type === 'activity-report' &&
        !API_URL.includes('kaah') && (
          <>
            <center>
              <button className="btn btn-danger" onClick={printAcivityReport}>
                Print Report
              </button>
            </center>

            <ActivityReport sections={report} link={link} />
          </>
        )}
      {report &&
        report.length > 0 &&
        link.form_type === 'form-report' &&
        link.route === 'balance-sheet' && (
          <>
            <BalanceSheet report={report} link={link} value={values} />
          </>
        )}
      {report &&
        report.length > 0 &&
        link.form_type === 'form-report' &&
        link.route === 'trial-balance' && (
          <>
            <TrialBalance report={report} link={link} value={values} />
          </>
        )}
      {report && report.length > 0 && link.form_type === 'map-report' && (
        <MapView data={report} link={link} />
      )}
      {report &&
        link.form_type !== 'activity-report' &&
        link.form_type !== 'map-report' &&
        link.route != 'balance-sheet' &&
        link.route != 'trial-balance' && (
          <DTTable
            data={report}
            reportHeader={reportHeader}
            reportFooter={reportFooter}
            link={link}
            token={token}
            executionTime={executionTime}
            editDelPermission={permissions}
          />
        )}
    </>
  );
};

export default ReportForm;
